import {Layout} from 'antd'
import * as React from 'react'
import {FC, useEffect} from 'react'
import {renderRoutes, RouteConfigComponentProps} from 'react-router-config'
import {useHistory} from 'react-router-dom'
import {getLocalAuthToken} from '../../services/api'
import {Sidebar} from './Sidebar'

type Props = RouteConfigComponentProps

export const AdminContainer: FC<Props> = (props) => {
  const history = useHistory()

  useEffect(() => {
    return history.listen((location) => {
      let _token = getLocalAuthToken()

      if (!_token || _token === undefined || _token === null) {
        history.push('/login')
      }
    })
  }, [history])

  return (
    <Layout>
      <Sidebar/>
      <Layout>
        {renderRoutes(props.route?.routes)}
      </Layout>
    </Layout>
  )
}
